import Header from '../../common/Header';
import Footer from '../../common/Footer';
import Guardian from '../../compnents/create/Guardian';
import ContractEditor from '../../compnents/create/ContractEditor';
import { useEffect, useState } from 'react';
import Payment from '../../compnents/create/Payment';
import Student from '../../compnents/create/StudentInfo';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';

const API_URL = 'http://localhost:3030';
const API_URL2 = process.env.REACT_APP_API_URL;

export default function Create() {
  const navigate = useNavigate();
  const location = useLocation();
  const [contractYears, setContractYears] = useState([]);
  const [selectedContractYear, setSelectedContractYear] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [selectedPath, setSelectedPath] = useState('public'); // Default to public path
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [settings, setSettings] = useState(null);

  // Check authentication status
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${API_URL2}/api/auth-check`, {
          credentials: 'include',
        });
        setIsAuthenticated(response.ok);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  // Get path selection from navigation state
  useEffect(() => {
    if (location.state && location.state.selectedPath) {
      setSelectedPath(location.state.selectedPath);
    }
  }, [location.state]);

  // Fetch contract years on component mount
  useEffect(() => {
    fetchContractYears();
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_URL2}/api/settings`);
      const data = await response.json();
      if (data.success) {
        setSettings(data.data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  // Fetch available contract years
  const fetchContractYears = async () => {
    try {
      const response = await fetch(`${API_URL2}/api/contract-variables`, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch contract years');
      }

      const data = await response.json();

      if (!data.data || !Array.isArray(data.data)) {
        throw new Error('Invalid data format received');
      }

      // Get all contracts without filtering by active status
      const years = data.data.map((contract) => {
        const yearString = `${contract.contractYear}_${contract.contractYearHijri}`;
        return {
          id: contract._id,
          year: yearString,
          isActive: contract.isActive, // Keep track of active status for display
        };
      });

      setContractYears(years);

      // If user is not authenticated, automatically select the latest contract year
      if (!isAuthenticated && years.length > 0) {
        // Sort years to get the latest one
        const sortedYears = [...years].sort((a, b) => {
          const [aYear] = a.year.split('_');
          const [bYear] = b.year.split('_');
          return bYear.localeCompare(aYear);
        });
        setSelectedContractYear(sortedYears[0].year);
      }
    } catch (err) {
      alert('حدث خطأ أثناء جلب السنوات الدراسية');
    }
  };

  // Define the initial state for `guardian`
  const [guardian, setGuardian] = useState(
    () =>
      loadFromLocalStorage('guardian') || {
        name: '',
        idNumber: '',
        relationship: '',
        absherMobileNumber: '',
        additionalMobileNumber: '',
        residentialAddress: '',
        profession: '',
        workAddress: '',
        workPhoneNumber: '',
        extension: '',
        contactPersons: [
          {
            name: '',
            relationship: '',
            mobileNumber: '',
          },
          {
            name: '',
            relationship: '',
            mobileNumber: '',
          },
        ],
      }
  );

  // Define the state for `contractEditor`
  const [contractEditor, setContractEditor] = useState(
    () =>
      loadFromLocalStorage('contractEditor') || {
        name: '',
        idNumber: '',
        relationship: '',
        absherMobileNumber: '',
        additionalMobileNumber: '',
        residentialAddress: '',
        profession: '',
        workAddress: '',
        workPhoneNumber: '',
        extension: '',
        educationalContact: {
          name: '',
          relationship: '',
          mobileNumber: '',
        },
        financialContact: {
          name: '',
          relationship: '',
          mobileNumber: '',
        },
      }
  );

  // Define the initial state for `student`
  const [student, setStudent] = useState(
    () =>
      loadFromLocalStorage('student') || {
        name: '',
        nationality: '',
        birthPlace: '',
        birthDate: '',
        idNumber: '',
        idIssueDate: '',
        idIssuePlace: '',
        previouslyEnrolled: null,
        hasRelation: null,
        relationshipName: '',
        requiredSchool: '',
        requiredStage: '',
        requiredGrade: '',
        hasSiblingsInIthraa: false,
        siblings: [
          {
            name: '',
            school: '',
            stage: '',
            grade: '',
          },
        ],
      }
  );

  // Define the initial state for `payment`
  const [payment, setPayment] = useState(
    () =>
      loadFromLocalStorage('payment') || {
        paymentType: '', // Default value
        transportation: {
          required: false, // Default value
          neighborhood: '',
          path: '', // Default value
        },
      }
  );

  // Add contract year to the initial state
  const [contractData, setContractData] = useState(
    () =>
      loadFromLocalStorage('contractData') || {
        contractYear: '',
      }
  );

  // Automatically save data when there's a change
  useEffect(() => {
    saveToLocalStorage('guardian', guardian);
  }, [guardian]);

  useEffect(() => {
    saveToLocalStorage('contractEditor', contractEditor);
  }, [contractEditor]);

  useEffect(() => {
    saveToLocalStorage('student', student);
  }, [student]);

  useEffect(() => {
    saveToLocalStorage('payment', payment);
  }, [payment]);

  useEffect(() => {
    saveToLocalStorage('contractData', contractData);
  }, [contractData]);

  return (
    <>
      <Header />

      {/* Popup Styles */}
      <style>
        {`
          .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          
          .popup-card {
            background: white;
            border-radius: 12px;
            padding: 30px;
            text-align: center;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
            max-width: 400px;
            width: 90%;
          }
          
          .popup-content {
            direction: rtl;
          }
          
          .popup-icon {
            font-size: 48px;
            margin-bottom: 20px;
          }
          
          .popup-content h4 {
            color: #28a745;
            margin-bottom: 15px;
            font-weight: bold;
          }
          
          .popup-content p {
            color: #666;
            margin: 0;
          }
        `}
      </style>

      {/* Success Popup Overlay */}
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-content">
              <div className="popup-icon">✅</div>
              <h4>تم إنشاء العقد بنجاح!</h4>
            </div>
          </div>
        </div>
      )}

      <div dir="rtl" className="container mt-2">
        <h2 className="fw-bold">عقد تسجيل طالب</h2>

        {/* Path Selection Indicator */}
        <div className="alert alert-info text-center mb-3" role="alert">
          <strong>المسار المختار:</strong>
          {selectedPath === 'american' ? (
            <span className="text-primary">
              المسار الأمريكي والدبلوم الأمريكي (عالمي)
            </span>
          ) : (
            <span className="text-success">المسار الأهلي (وطني)</span>
          )}
        </div>

        <hr />

        <form onSubmit={handleSubmit} noValidate>
          {/* Contract Year Selection - Only show if authenticated */}
          {isAuthenticated && (
            <Box sx={{ mb: 3 }}>
              <FormControl fullWidth required>
                <InputLabel>السنة الدراسية للعقد</InputLabel>
                <Select
                  value={selectedContractYear}
                  onChange={(e) => setSelectedContractYear(e.target.value)}
                  label="السنة الدراسية للعقد"
                >
                  {contractYears.map((year) => (
                    <MenuItem
                      key={year.id}
                      value={year.year}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>{year.year}</span>
                      {year.isActive && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'success.main',
                            bgcolor: 'success.light',
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            fontSize: '0.75rem',
                            mr: 1,
                          }}
                        >
                          نشط
                        </Typography>
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

          <Guardian data={guardian} setData={setGuardian} />
          <hr />
          <ContractEditor data={contractEditor} setData={setContractEditor} />
          <hr />
          <Student
            data={student}
            setData={setStudent}
            selectedPath={selectedPath}
          />
          <hr />
          <Payment data={payment} setData={setPayment} />
          <div className="text-center w-100">
            <button type="submit" className="btn btn-success w-75 text-center">
              {settings?.saveTrigger === 'signature_page'
                ? 'المتابعة للتوقيع'
                : 'حفظ العقد'}
            </button>
          </div>
        </form>
        <div className="text-center mt-3 w-100">
          <button
            onClick={clearAllFields}
            className="btn btn-danger w-75 text-center"
          >
            حذف الكل
          </button>
        </div>
      </div>
      <Footer />
    </>
  );

  // Save data to localStorage
  function saveToLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  // Load data from localStorage
  function loadFromLocalStorage(key) {
    const savedData = localStorage.getItem(key);
    return savedData ? JSON.parse(savedData) : null;
  }

  function validateRequiredFields() {
    const requiredFields = document.querySelectorAll('[required]');
    for (let field of requiredFields) {
      if (!field.value || field.value.trim() === '') {
        const label = field
          .closest('.form-group')
          ?.querySelector('label')?.innerText;

        alert(`يرجى ملء الحقل المطلوب: ${label || 'حقل غير معروف'}`);

        field.focus(); // Focus on the missing field
        return false; // Stop checking after the first error
      }
    }

    return true; // All fields are filled
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (!validateRequiredFields()) {
      return;
    }

    // Only check for selectedContractYear if user is authenticated
    if (isAuthenticated && !selectedContractYear) {
      alert('يرجى اختيار السنة الدراسية للعقد');
      return;
    }

    const requestData = {
      contractYear: selectedContractYear,
      guardian,
      contractEditor,
      student,
      payment: {
        ...payment,
        isKindergartenAmerican:
          selectedPath === 'american' &&
          student.requiredStage === 'Kindergarten',
        isElementaryAmerican:
          selectedPath === 'american' && student.requiredStage === 'Elementary',
      },
    };

    fetch(`${API_URL2}/api/user/create`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Clear localStorage after successful submission
        localStorage.removeItem('guardian');
        localStorage.removeItem('contractEditor');
        localStorage.removeItem('student');
        localStorage.removeItem('payment');
        localStorage.removeItem('contractData');

        // Always navigate to signature page
        // The saveTrigger setting determines WHEN the contract is saved:
        // - 'create_page': Already saved above, signature page just shows preview
        // - 'signature_page': Will be saved after signature in signature page
        if (data.contract && data.contract._id) {
          navigate(`/signature/${data.contract._id}`);
        } else {
          alert('حدث خطأ: لم يتم إرجاع معرف العقد');
        }
      })
      .catch((error) => {
        alert('حدث خطأ أثناء حفظ العقد');
      });
  }

  function clearAllFields() {
    // Clear all form data
    setGuardian({
      name: '',
      idNumber: '',
      relationship: '',
      absherMobileNumber: '',
      additionalMobileNumber: '',
      residentialAddress: '',
      profession: '',
      workAddress: '',
      workPhoneNumber: '',
      extension: '',
      contactPersons: [
        { name: '', relationship: '', mobileNumber: '' },
        { name: '', relationship: '', mobileNumber: '' },
      ],
    });
    setContractEditor({
      name: '',
      idNumber: '',
      relationship: '',
      absherMobileNumber: '',
      additionalMobileNumber: '',
      residentialAddress: '',
      profession: '',
      workAddress: '',
      workPhoneNumber: '',
      extension: '',
    });
    setStudent({
      name: '',
      nationality: '',
      birthPlace: '',
      birthDate: '',
      idNumber: '',
      idIssueDate: '',
      idIssuePlace: '',
      previouslyEnrolled: null,
      requiredSchool: '',
      requiredStage: '',
      requiredGrade: '',
      hasSiblingsInIthraa: false,
      siblings: [{ name: '', school: '', stage: '', grade: '' }],
    });
    setPayment({
      paymentType: '',
      transportation: {
        required: false,
        neighborhood: '',
        path: '',
      },
    });
    setSelectedContractYear('');

    // Clear localStorage
    localStorage.removeItem('guardian');
    localStorage.removeItem('contractEditor');
    localStorage.removeItem('student');
    localStorage.removeItem('payment');
    localStorage.removeItem('contractData');
  }
}
